// extracted by mini-css-extract-plugin
export default {"emailLabel":"EmailForm_emailLabel__2vxPp","emailInput":"EmailForm_emailInput__1295+","placeHolderShimmer":"EmailForm_placeHolderShimmer__veqAF"};